<template>
    <div>
        <error-notifications :errors.sync="errors"></error-notifications>
        <form id="login" class="has-text-left" @submit.prevent="logIn">
            <div class="field" :class="{'is-horizontal': horizontal}">
                <div v-if="horizontal" class="field-label is-normal">
                    <label class="label" for="username">Username</label>
                </div>
                <label v-else class="label" for="username">Username</label>
                <div class="field-body">
                    <div class="control has-icons-left">
                        <input id="username" class="input" type="text" name="username" v-model="username" required>
                        <span class="icon is-small is-left">
                            <i class="fas fa-user"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="field" :class="{'is-horizontal': horizontal}">
                <div v-if="horizontal" class="field-label is-normal">
                    <label class="label" for="password">Password</label>
                </div>
                <label v-else class="label" for="password">Password</label>
                <div class="field-body">
                    <div class="control has-icons-left">
                        <input id="password" class="input" type="password" name="password" v-model="password" required>
                        <span class="icon is-small is-left">
                            <i class="fas fa-lock"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="field" :class="{'is-horizontal': horizontal}">
                <input class="button" type="submit" value="Log In" :style="{ margin: horizontal? 'auto':'inherit'}">
            </div>
        </form>
    </div>
</template>
<script>
    import ErrorNotifications from "heat-shared/src/components/ErrorNotifications";
    import {mapState} from "vuex";

    export default {
        components: {ErrorNotifications},
        props: {
            "horizontal": {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                'username': '',
                'password': '',
                'errors': [],
            }
        },
        computed: {
            ...mapState('user', [
                'isStaff',
            ]),
        },
        methods: {
            async logIn() {
                this.errors = [];
                let redirect_to = this.$route.query.next || null;
                try {
                    await this.$store.dispatch('user/login', [this.username, this.password]);
                    if(redirect_to !== null){
                        this.$router.push(redirect_to);
                        return;
                    }
                    if(this.isStaff) {
                        this.$router.push({name: 'staff_home'});
                    }
                } catch (responseData) {
                    this.errors = Object.values(responseData);
                }
            }
        }
    }
</script>
<style>
    /*Everything uses the Bulma CSS framework with Buefy*/
</style>
